import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="font-mono text-sm text-muted-foreground animate-pulse" data-testid="app-loading">
        Loading Maria's Forex / Crypto…
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checking } = useAuth();
  if (checking || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
